import GenericRequest, { METHOD_GET } from '../../../../../shared/webservices/GenericRequest';

export class CompanyDetailTask extends GenericRequest {

    _request; // CompanyDetailRequest

    constructor(request) {
        super(METHOD_GET, request.route());
    }

    overrideRequest() {}
}



// WEBPACK FOOTER //
// ./src/app/my-company/company/form/update/company-detail/CompanyDetailTask.js